import { getYearFormatter } from "../../helpers"
import { getAuthHeaders } from "../auth"
import { GET_EMPLOYEE_DASHBOARD_EVENTS,GET_ADMIN_WEEKLY_REPORT, GET_EMPLOYEE_MONTHLY_STATS,ADMIN_DASHBOARD_INFO } from "../constants"
export const getEmployeeDashboardServiceConfig = ({ firstDay, lastDay }) => {
    const payload = {
        "StartDate": getYearFormatter(firstDay),
        "EndDate": getYearFormatter(lastDay)
    }
    return {
        url: GET_EMPLOYEE_DASHBOARD_EVENTS,
        options: {
            method: "POST",
            body: JSON.stringify(payload),
            headers: getAuthHeaders()
        }

    }
}
export const getMonthlyStatisticsReqConfig = ({firstDay,lastDay}) => {
    const payload = {
        "StartDate": getYearFormatter(firstDay),
        "EndDate": getYearFormatter(lastDay)
    }
    return {
        url: GET_EMPLOYEE_MONTHLY_STATS,
        options: {
            method: "POST",
            body: JSON.stringify(payload),
            headers: getAuthHeaders()
        }
    }
}

export const getEmployerDashboardReqConfig = (firstDay,lastDay)=>{
    const payload = {
        "StartDate": getYearFormatter(firstDay),
        "EndDate": getYearFormatter(lastDay)
    }
    return {
        url:ADMIN_DASHBOARD_INFO,
        options: {
            method: "POST",
            body: JSON.stringify(payload),
            headers: getAuthHeaders()
        }
    }
}

export const getCurrentWeekReportReqConfig = ({firstDay,lastDay})=>{
    const payload = {
        "StartDate": getYearFormatter(firstDay),
        "EndDate": getYearFormatter(lastDay)
      }
    return {
        url:GET_ADMIN_WEEKLY_REPORT,
        options:{
            method:"POST",
            body:JSON.stringify(payload),
            headers:getAuthHeaders()
        }
    }
}